import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import MentalsIndex from './pages/MentalsIndex';
import MentalLessonIndex from './pages/MentalLessonIndex';
import Favorites from './pages/Favorites';
import SingleLesson from './pages/SingleLesson';
import MentalKnowHow from './pages/MentalKnowHow';
import MentalKnowHowText from './pages/MentalKnowHowText';
import PageNotFound from './components/PageNotFound';

import './App.css';
import MultipartLessonIndex from './pages/MultipartLessonIndex';
import ApiLoadingWrapper from './components/ApiLoadingWrapper';
import ScrollToTop from './components/ScrollToTop';
import HistoryNotifyer from './components/HistoryNotifyer';

const App: React.FC = () => (
    <ApiLoadingWrapper>
        <Router basename={process.env.PUBLIC_URL}>
            <HistoryNotifyer />
            <div className="container">
                <ScrollToTop>
                    <Switch>
                        <Route path="/" exact component={MentalsIndex} />

                        {/* Einzelne Übung einer Mehrfachübung */}
                        <Route
                            path="/mental/:mentalId/:mentalSlug/uebung/:parentLessonId/:parentLessonSlug/:lessonId/:lessonSlug"
                            component={SingleLesson}
                        />

                        {/* Einzelne Übung */}
                        <Route
                            path="/mental/:mentalId/:mentalSlug/uebung/:lessonId/:lessonSlug"
                            component={SingleLesson}
                        />

                        <Route
                            path="/mental/:mentalId/:mentalSlug/know-how"
                            exact
                            component={MentalKnowHow}
                        />
                        <Route
                            path="/mental/:mentalId/:mentalSlug/know-how/:knowHowIndex/:knowHowSlug"
                            exact
                            component={MentalKnowHowText}
                        />

                        <Route path="/mental/:mentalId/:mentalSlug" component={MentalLessonIndex} />

                        <Route path="/favoriten" component={Favorites} />
                        <Route
                            component={() => (
                                <PageNotFound
                                    title="Nicht gefunden"
                                    showMentalIndexLink
                                    message={(
                                        <p>
                                            Die Seite wurde nicht gefunden.&nbsp;
                                            Falls dieses Problem wiederholt auftritt,&nbsp;
                                            wende dich bitte an&nbsp;
                                            <a href="mailto:hello@elemental-app.com">
                                                hello@elemental-app.com
                                            </a>
                                            .
                                        </p>
                                    )}
                                />
                            )
                            }
                        />
                    </Switch>
                </ScrollToTop>
            </div>
            <div>
                <Switch>
                    {/* Detailansicht für Mehrfachübung */}
                    <Route
                        path="/mental/:mentalId/:mentalSlug/uebung-auswahl/:lessonId/:lessonSlug"
                        component={(props: any) => (
                            <MultipartLessonIndex {...props} />
                        )}
                    />
                </Switch>
            </div>
        </Router>
    </ApiLoadingWrapper>
);

export default App;
